// extracted by mini-css-extract-plugin
export default {"description":"ModalImage_description__05Stp","title":"ModalImage_title__0YBSq","imageBG":"ModalImage_imageBG__QWFBQ","imageContainer":"ModalImage_imageContainer__c4jk5"};